/** "Chrome 141 · Windows" from a User-Agent string; the raw string when it is not recognized. */
export function browserSummary(userAgent: string | null): string | null {
  if (!userAgent) return null;
  const version = (name: string) => new RegExp(`${name}/(\\d+)`).exec(userAgent)?.[1];
  const browser = version('Edg')
    ? `Edge ${version('Edg')}`
    : version('OPR')
      ? `Opera ${version('OPR')}`
      : version('Firefox')
        ? `Firefox ${version('Firefox')}`
        : version('Chrome')
          ? `Chrome ${version('Chrome')}`
          : version('Version') && userAgent.includes('Safari')
            ? `Safari ${version('Version')}`
            : null;
  const system = /Windows/.test(userAgent)
    ? 'Windows'
    : /iPhone|iPad/.test(userAgent)
      ? 'iOS'
      : /Mac OS X/.test(userAgent)
        ? 'macOS'
        : /Android/.test(userAgent)
          ? 'Android'
          : /Linux/.test(userAgent)
            ? 'Linux'
            : null;
  return browser ? [browser, system].filter(Boolean).join(' · ') : userAgent;
}
